module.exports = __webpack_public_path__ + "img/a22.1b28e877.png";